import DateRange from './DateRange';
import MobileDateRange from './MobileDateRange';

export default DateRange;

export { MobileDateRange };
